import defineComponent from 'flight';

function SelectPaymentUI() {
    this.defaultAttrs({
        paypalUrl: '[data-paypal-url]',
        paypalLink: '[data-paypal]',
        paypalVisaMastercardLink: '[data-paypal-visa-mastercard]'
    });

    this.after('initialize', function () {
        if (this.select('paypalLink').length > 0) {
            window.paypalReturnCallback =
                function () {
                    document.location = this.select('paypalUrl').val();
                }.bind(this);

            window.dgFlowMini = new window.PAYPAL.apps.DGFlowMini({ trigger: 'btnBuyPayPal', expType: 'mini', callbackFunction: 'paypalReturnCallback' });

            if (this.select('paypalVisaMastercardLink').length > 0) {
                window.dgFlowMini.setTrigger('btnBuyPayPalVisaMCard');
            }
        }
    });
}

export default defineComponent.component(SelectPaymentUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout/select-payment-ui.js